import fetch from 'isomorphic-fetch';
import qs from 'query-string';

import { checkStatus, parseJSON, dispatchError } from '../utils/fetch';
import {
  CLEAR_RESERVATIONS_REQUEST,
  CLEAR_RESERVATIONS_FAILURE,
  CLEAR_RESERVATIONS_SUCCESS,
  CLEAR_RESERVATIONS_TIMEOUT
} from '../constants/ActionTypes';

function clearReservationsRequest(sale) {
  return {
    type: CLEAR_RESERVATIONS_REQUEST,
    sale
  };
}

function clearReservationsFailure(sale) {
  return {
    type: CLEAR_RESERVATIONS_FAILURE,
    sale
  };
}

function clearReservationsSuccess(sale) {
  return {
    type: CLEAR_RESERVATIONS_SUCCESS,
    sale,
    timeout: setTimeout(clearReservationsTimeout, 5000)
  };
}

function clearReservationsTimeout() {
  return {
    type: CLEAR_RESERVATIONS_TIMEOUT
  };
}

export default function clearReservations() {
  return (dispatch, getState) => {
    const config = getState().config;

    const {
      sale: { sale }
    } = getState();

    if (sale == null || sale.id == null) {
      return; // probably already cleared there's some weird setTimeout stuff that I added that might cause this logic to be needed
    }

    dispatch(clearReservationsRequest(sale));

    return fetch(
      `${config.apiUrl}/sales/${sale.id}/clearreservations?${qs.stringify({
        client: config.client
      })}`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(() => {
        dispatch(clearReservationsSuccess(sale));
      })
      .catch((...args) => {
        dispatchError(dispatch, clearReservationsFailure.bind(this, sale))(
          ...args
        );
      });
  };
}
